import moment from 'moment';
import columns from '../../../../../react-table/helpers/columns';

export const resdesArrivalLocationConditionalProps = (state, rowInfo) => {
  let className = '';
  if (rowInfo) {
    if (rowInfo.row.lastLegArrivalLocation !== rowInfo.row.resdesArrivalLocation) {
      className = 'text-red';
    }
  }
  return {
    className,
  };
};

export const procDateLastConditionalProps = (state, rowInfo) => {
  let className = '';
  if (rowInfo) {
    const { row } = rowInfo;
    if (row) {
      if (moment(row.resdesLastScanDate) > moment(row.criticalScanTime)) {
        className = 'text-red';
      }
      if (moment(row.resdesLastScanDate) <= moment(row.criticalScanTime)) {
        className = 'text-green';
      }
    }
  }
  return {
    className,
  };
};

export const procDateFirstConditionalProps = (state, rowInfo) => {
  let className = '';
  if (rowInfo) {
    const { row } = rowInfo;
    if (row) {
      if (moment(row.resdesFirstScanDate) > moment(row.criticalScanTime)) {
        className = 'text-red';
      }
      if (moment(row.resdesFirstScanDate) <= moment(row.criticalScanTime)) {
        className = 'text-green';
      }
    }
  }
  return {
    className,
  };
};

export default (data) => {
  const {
    TextColumn, NumberColumn, DateTimeColumn, ExternalDespatchLinkColumn,
  } = columns(data);
  return [
    {
      Header: 'PREDES',
      columns: [
        new ExternalDespatchLinkColumn(new TextColumn('Despatch ID', 'despatchId')),
        new DateTimeColumn('Close date', 'despatchClosedDate'),
        new NumberColumn('Receptacles preadvised', 'predesReceptacleCount'),
        new TextColumn('Last leg conveyance reference', 'lastLegConveyanceReference'),
        new TextColumn('Last leg arrival location', 'lastLegArrivalLocation'),
        new DateTimeColumn('Last leg planned arrival', 'lastLegPlannedArrivalDateTime'),
      ],
    },
    new DateTimeColumn('LAT', 'lastArrivalTime'),
    {
      Header: 'RESDES',
      columns: [
        new NumberColumn('Receptacles responded', 'resdesCount'),
        new TextColumn('Conveyance reference', 'resdesConveyanceReference'),
        new TextColumn('Arrival location', 'resdesArrivalLocation').withGetProps(resdesArrivalLocationConditionalProps),
        new DateTimeColumn('Arrival date', 'resdesArrivalDate'),
        new DateTimeColumn('Proc date first', 'resdesFirstScanDate').withGetProps(procDateFirstConditionalProps),
        new DateTimeColumn('Proc date last', 'resdesLastScanDate').withGetProps(procDateLastConditionalProps),
      ],
    },
    new DateTimeColumn('CST', 'criticalScanTime'),
  ];
};
